// Fetch list

export const FETCH = 'reportCostCenterCost.FETCH'
export const FETCH_STARTED = 'reportCostCenterCost.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCostCenterCost.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCostCenterCost.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCostCenterCost.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportCostCenterCost.EXPORT'
export const EXPORT_FULFILLED = 'reportCostCenterCost.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportCostCenterCost.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportCostCenterCost.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCostCenterCost.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCostCenterCost.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCostCenterCost.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCostCenterCost.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportCostCenterCost.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCostCenterCost.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportCostCenterCost.CLEAR_DETAILS'
